import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AnswerForm from './components/AnswerForm';
import PublicAnswer from './components/PublicAnswer';
import AuthCallback from './components/AuthCallback';
import PrivateRoute from './components/PrivateRoute';
import AllAnswers from './components/AllAnswers';
import QRScanner from './components/QRScanner';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/answer/:shortId" element={<PublicAnswer />} />

          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/create" element={
            <PrivateRoute>
              <AnswerForm />
            </PrivateRoute>
          } />

          <Route path="/edit/:id" element={
            <PrivateRoute>
              <AnswerForm />
            </PrivateRoute>
          } />

          <Route path="/all-answers" element={
            <PrivateRoute>
              <AllAnswers />
            </PrivateRoute>
          } />

          <Route path="/qr-scanner" element={
            <PrivateRoute>
              <QRScanner />
            </PrivateRoute>
          } />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;